// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimulatorApp{background-color:#f8f9fa}", "",{"version":3,"sources":["webpack://./resources/js/frontend/simulator/App.styles.scss"],"names":[],"mappings":"AAAA,cACI,wBACJ","sourcesContent":[".SimulatorApp {\n    background-color: #F8F9FA;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
